import styled from "styled-components";
import { Link } from "react-router-dom";
import { updateCategory } from "../redux/productRedux";
import { useDispatch } from "react-redux";

const Container = styled.div`
  flex: 1;
  margin: 3px;
  height: 70vh;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
const Info = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h2 {
    color: white;
    margin-bottom: 20px;
  }

  .button {
  }
`;
const Button = styled.button`
  border: none;
  padding: 17px;
  background-color: white;
  border-radius: 5px;
  color: gray;
  cursor: pointer;
  font-weight: 600;
  text-decoration: none;
`;

export default function CategoryItem({ item }) {
  const dispatch = useDispatch();

  const handleClick = e => {
    dispatch(updateCategory(e.target.value));
  };

  return (
    <Container>
      <img src={item.img} alt="" />
      <Info>
        <h2>{item.title}</h2>
        <Link to="/products">
          <Button
            className="button"
            onClick={handleClick}
            value={item.category}
          >
            SHOP NOW
          </Button>
        </Link>
      </Info>
    </Container>
  );
}
